import { api } from '@/api'
import type { ConfigTemplate, ConfigTemplateResponse, ConfigTemplatesResponse } from '../types'

// GET /bff/configtemplates → { templates }.
export function listConfigTemplates(): Promise<ConfigTemplate[]> {
  return api.get<ConfigTemplatesResponse>('/configtemplates').then((data) => data.templates)
}

// POST /bff/configtemplates → { template }.
export function registerConfigTemplate(template: ConfigTemplate): Promise<ConfigTemplate> {
  return api.post<ConfigTemplateResponse>('/configtemplates', { body: template }).then((data) => data.template)
}

// PUT /bff/configtemplates/{id} → { template }.
export function updateConfigTemplate(template: ConfigTemplate): Promise<ConfigTemplate> {
  return api
    .put<ConfigTemplateResponse>(`/configtemplates/${template.id}`, { body: template })
    .then((data) => data.template)
}

// DELETE /bff/configtemplates/{id} → { template }.
export function deleteConfigTemplate(id: string): Promise<ConfigTemplate> {
  return api.delete<ConfigTemplateResponse>(`/configtemplates/${id}`).then((data) => data.template)
}
